import React from 'react'

import { FormattedCurrency, FormattedHTMLMessage } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import { SettingsTabs } from '../../types'
import s from './s.module.css'
import Menu from './Menu'
import { lang } from './lang'

interface Props {
    setTab: (tab: SettingsTabs) => void
    tab: SettingsTabs
    card?: GetCard
}

// eslint-disable-next-line complexity
function General({ tab, setTab, card }: Props) {
    const topupFees = card?.fees?.topup

    return (
        <div className={s.wrap}>
            <Menu tab={tab} setTab={setTab} />
            <div className={s.divider} />
            <div className={s.balances}>
                {card?.fees?.monthly?.fixed && (
                    <div className={s.middleRow}>
                        <FormattedHTMLMessage {...lang.monthFee} className={s.middleTitle} />
                        <span className={s.middleText}>
                            <FormattedCurrency
                                maxPrecision={2}
                                value={card?.fees?.monthly?.fixed}
                                currency={card?.fees?.monthly?.currency}
                                dataPointer="min_fee"
                            />
                        </span>
                    </div>
                )}
                {(topupFees?.fixed || topupFees?.percent) && (
                    <div className={s.middleRow}>
                        <FormattedHTMLMessage {...lang.topUpFee} className={s.middleTitle} />
                        <div className={s.fee}>
                            <span className={s.middleText}>
                                <FormattedCurrency
                                    maxPrecision={2}
                                    value={topupFees?.fixed}
                                    currency={topupFees?.currency}
                                    dataPointer="min_fee"
                                />
                                {topupFees?.fixed && topupFees?.percent ? ' + ' : undefined}
                                {topupFees?.percent}
                                {topupFees?.percent ? '%' : ''}
                            </span>
                            <span className={s.minMaxText}>
                                {topupFees?.min ? (
                                    <>
                                        <FormattedHTMLMessage {...lang.min} />{' '}
                                        <FormattedCurrency
                                            maxPrecision={2}
                                            value={topupFees?.min}
                                            currency={card?.currency}
                                            dataPointer="min_fee"
                                        />
                                    </>
                                ) : undefined}
                                {topupFees?.min && topupFees?.max ? ', ' : undefined}
                                {topupFees?.max ? (
                                    <>
                                        <FormattedHTMLMessage {...lang.max} />{' '}
                                        <FormattedCurrency
                                            maxPrecision={2}
                                            value={topupFees?.max}
                                            currency={card?.currency}
                                            dataPointer="max_fee"
                                        />
                                    </>
                                ) : undefined}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default General
